<template>
  <div class="text-sm flex flex-col gap-1">
    <template v-if="shipType === VESSEL_TYPE()">
      <vs-row vs-w="12">
        <vs-col vs-w="5">
          <span> Vessel Name </span>
        </vs-col>
        <vs-col
          vs-w="7"
          class="data"
          :style="{color: data.color}"
        >
          <span> {{ data.vessel_name || 'N/A' }} </span>
        </vs-col>
      </vs-row>
      <vs-row vs-w="12">
        <vs-col vs-w="5">
          <span> LayCan of Vessel </span>
        </vs-col>
        <vs-col
          vs-w="7"
          class="data text-primary"
        >
          <span> {{ validateAndFormatDate(data.lay) }} - {{ validateAndFormatDate(data.can) }} </span>
        </vs-col>
      </vs-row>
      <vs-row vs-w="12">
        <vs-col vs-w="5">
          <span> Buyer </span>
        </vs-col>
        <vs-col
          vs-w="7"
          class="data text-primary"
        >
          <span>
            {{ data.buyer || 'N/A' }}
          </span>
        </vs-col>
      </vs-row>
      <vs-row vs-w="12">
        <vs-col vs-w="5">
          <span> Shipper </span>
        </vs-col>
        <vs-col
          vs-w="7"
          class="data text-primary"
        >
          <span> {{ data.company || 'N/A' }} </span>
        </vs-col>
      </vs-row>
      <vs-row vs-w="12">
        <vs-col vs-w="5">
          <span> ETA </span>
        </vs-col>
        <vs-col
          vs-w="7"
          class="data text-primary"
        >
          <span> {{ validateAndFormatDate(data.eta, 'DD MMM YYYY HH:mm') || 'N/A' }} </span>
        </vs-col>
      </vs-row>
      <vs-row vs-w="12">
        <vs-col vs-w="5">
          <span> ATA </span>
        </vs-col>
        <vs-col
          vs-w="7"
          class="data text-primary"
        >
          <span> {{ validateAndFormatDate(data.ata, 'DD MMM YYYY HH:mm') || 'N/A' }} </span>
        </vs-col>
      </vs-row>
    </template>
    <template v-else>
      <vs-row vs-w="12">
        <vs-col vs-w="5">
          <span> Trip Number </span>
        </vs-col>
        <vs-col
          vs-w="7"
          class="data"
        >
          <div
            v-if="data.trip_number && data.trip_number === 'N/A'"
            class="bg-red-200 border border-red-600 rounded-md p-1 text-danger"
          >
            BLU is not generated yet
          </div>
          <span v-else> {{ data.trip_number || 'N/A' }} </span>
        </vs-col>
      </vs-row>
      <vs-row vs-w="12">
        <vs-col vs-w="5">
          <span> Status </span>
        </vs-col>
        <vs-col
          vs-w="7"
          class="data"
        >
          <span
            class="capitalize"
            :class="{
              'text-success': data.shipment_status && data.shipment_status.toLowerCase() === 'on time',
              'text-danger': data.shipment_status && data.shipment_status.toLowerCase() === 'late'
            }"
          >
            [{{ data.shipment_status ? data.shipment_status.toLowerCase() : 'N/A' }}]
          </span>
          <span class="text-secondary capitalize">
            {{ statusBLU }}
          </span>
        </vs-col>
      </vs-row>
      <vs-row vs-w="12">
        <vs-col vs-w="5">
          <span> Vessel Name </span>
        </vs-col>
        <vs-col
          vs-w="7"
          class="data"
        >
          <span
            class="font-semibold underline cursor-pointer"
            :style="{color: data.vessel_name && data.vessel_name !== 'N/A' ? data.color : '#6546c3'}"
            @click="() => $emit('viewVesselDetail', data.vessel_name)"
          >
            {{ data.vessel_name }}
          </span>
        </vs-col>
      </vs-row>
      <vs-row vs-w="12">
        <vs-col vs-w="5">
          <span> Tug Name </span>
        </vs-col>
        <vs-col
          vs-w="7"
          class="data"
        >
          <span :style="{color: data.vessel_name && data.vessel_name !== 'N/A' ? data.color : '#6546c3'}">
            {{ data.tugboat_name }}
          </span>
        </vs-col>
      </vs-row>
      <vs-row vs-w="12">
        <vs-col vs-w="5">
          <span> Barge Name </span>
        </vs-col>
        <vs-col
          vs-w="7"
          class="data"
        >
          <span :style="{color: data.vessel_name && data.vessel_name !== 'N/A' ? data.color : '#6546c3'}">
            {{ data.barge_name }}
          </span>
        </vs-col>
      </vs-row>
    </template>
  </div>
</template>

<script>

import moment from "moment/moment";

import {VESSEL_TYPE} from "@/fixtures/Constants";

export default {
  name: 'GeneralInformation',
  methods: {
    VESSEL_TYPE() {
      return VESSEL_TYPE
    },
    validateAndFormatDate(date, format = "DD MMM YYYY") {
      if (!date || date === '-') {
        return null
      }
      const parsedDate = this.moment(date, ['DD-DD/M', 'YYYY-MM-DDTHH:mm:ss.SSSSZ', format], true)
      if (parsedDate.isValid()) {
        if (this.moment(date, format, true).isValid()) { // date already in correct format
          return date
        }
        return moment.utc(parsedDate).local().format(format)
      }
      return null;
    }
  },
  props: {
    shipType: {
      type: String,
      default: () => 'vessel'
    },
    data: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    statusBLU() {
      const status = this.data.blu_status 
        ? this.data.blu_status.toLowerCase()
        : 'N/A'
      return status
    }
  }
}
</script>

<style lang="scss" scoped>
.data {
  @apply flex justify-end;
  @apply text-right;
}
</style>